// src/i18n/locales/ar/categories.ts
export const arCategoriesTranslations = {
	categories: {
		// Categories page
		title: 'فئات القائمة',
		subtitle: 'تنظيم عناصر القائمة الخاصة بك في فئات',
		addCategory: 'إضافة فئة',
		editCategory: 'تعديل الفئة',
		deleteCategory: 'حذف الفئة',

		// خصائص الفئة
		name: 'اسم الفئة',
		description: 'الوصف',
		image: 'صورة الفئة',
		displayOrder: 'ترتيب العرض',
		published: 'منشور',
		thumbnail: 'الصورة المصغرة',
		categoryImage: 'صورة الفئة',
		parentCategory: 'الفئة الرئيسية',
		noParent: 'بدون فئة رئيسية',
		addMainCategory: 'إضافة فئة رئيسية',
		addSubcategory: 'إضافة فئة فرعية',
		subcategories: 'الفئات الفرعية',
		mainCategory: 'فئة رئيسية',
		subcategory: 'فئة فرعية',
		categoryType: 'نوع الفئة',

		// Status labels
		draft: 'مسودة',

		// Empty states
		noCategories: 'لا توجد فئات حتى الآن',
		noCategoriesYet: 'ليس لديك أي فئات حتى الآن',
		noCategoriesTooltip: 'قم بإنشاء فئات لتنظيم عناصر القائمة الخاصة بك',
		createFirstCategory: 'إنشاء الفئة الأولى',
		noMatchingCategories: 'لم يتم العثور على فئات مطابقة',
		tryAdjustingFilters: 'حاول تعديل البحث أو المرشحات',
		noSubcategories: 'لا توجد فئات فرعية حتى الآن',
		addSubcategoryDescription: 'أنشئ فئات فرعية لتنظيم عناصر القائمة بشكل أفضل',
		addFirstSubcategory: 'إضافة أول فئة فرعية',

		// Actions
		publish: 'نشر',
		unpublish: 'إلغاء النشر',
		backToCategories: 'العودة إلى الفئات',
		noDescription: 'لا يوجد وصف',
		itemCount: '{{count}} عنصر',
		itemCount_plural: '{{count}} عناصر',
		lastUpdated: 'آخر تحديث',
		menuItems: 'عناصر القائمة',
		viewItems: 'عرض العناصر',
		clickToManage: 'انقر للإدارة',
		viewParent: 'عرض الفئة الرئيسية',

		// Info messages
		mainCategoryInfo: 'هيكل الفئة الرئيسية',
		mainCategoryDescription: 'تُستخدم الفئات الرئيسية لتنظيم الفئات الفرعية. يمكن إضافة عناصر القائمة فقط إلى الفئات الفرعية وليس الفئات الرئيسية.',

		// Category details
		categoryDetails: 'تفاصيل الفئة',

		// Modals and confirmations
		deleteTitle: 'حذف الفئة',
		deleteMessage: 'هل أنت متأكد من رغبتك في حذف "{{name}}"؟ لا يمكن التراجع عن هذا الإجراء.',
		deleteConfirmation: 'هل أنت متأكد من رغبتك في حذف "{{name}}"؟ سيؤدي هذا أيضًا إلى حذف جميع عناصر القائمة في هذه الفئة. لا يمكن التراجع عن هذا الإجراء.',

		englishDetails: 'التفاصيل الإنجليزية',
		arabicDetails: 'التفاصيل العربية',
		enName: 'الاسم الإنجليزي',
		arName: 'الاسم العربي',
		arNamePlaceholder: 'أدخل اسم الفئة',
		enDescription: 'الوصف الإنجليزي',
		arDescription: 'الوصف العربي',
		arDescriptionPlaceholder: 'وصف هذه الفئة...',

		categoryStats: 'إحصائيات الفئة',
		createdAt: 'تاريخ الإنشاء',

		basicInformation: 'المعلومات الأساسية',
		parentCategoryHelper: 'اختر فئة رئيسية لإنشاء فئة فرعية، أو اتركها فارغة للفئة الرئيسية',
		arabicTranslation: 'الترجمة العربية',
		imageAndSettings: 'الصورة والإعدادات',
		settings: 'إعدادات الفئة',
		mainCategoryHelper: 'ستكون هذه فئة رئيسية يمكن أن تحتوي على فئات فرعية',
		unpublishedHelper: 'الفئة غير مرئية للعملاء',
		publishedHelper: 'الفئة مرئية للعملاء',
		mainCategoryType: 'فئة رئيسية',
		subcategoryType: 'فئة فرعية',
		subcategoryHelper: 'ستكون هذه فئة فرعية تحت الفئة الرئيسية المحددة',

		// Errors
		notFound: 'الفئة غير موجودة',
		notFoundDescription: 'الفئة التي تبحث عنها غير موجودة أو تمت إزالتها.',
		errors: {
			nameRequired: 'اسم الفئة مطلوب',
			createFailed: 'فشل في إنشاء الفئة. الرجاء المحاولة مرة أخرى.',
			updateFailed: 'فشل في تحديث الفئة. الرجاء المحاولة مرة أخرى.',
			arNameRequired: 'الاسم العربي مطلوب',
		},

		add: "إضافة فئة",
		edit: "تعديل الفئة",
		namePlaceholder: "أدخل اسم الفئة",
		descriptionPlaceholder: "أدخل وصف الفئة (اختياري)",
		uploadImage: "انقر لتحميل صورة",

		updateCategory: 'تحديث الفئة',

		manageItems: 'إدارة العناصر',
		gridView: 'عرض الشبكة',
		listView: 'عرض القائمة',
		status: 'الحالة',

		manageMenuItems: 'إدارة عناصر القائمة',
		manageMenuItemsDescription: 'أضف ونظم عناصر القائمة لهذه الفئة. يمكن إضافة عناصر القائمة فقط إلى الفئات الفرعية.',
		goToMenuItems: 'الذهاب إلى عناصر القائمة',
		quickAddItem: 'إضافة سريعة',
		categoryItemsHint: 'يمكنك أيضًا إضافة العناصر مباشرة من صفحة عناصر القائمة',
		menuItemsCount: '{{count}} عنصر في هذه الفئة',
		menuItemsCount_plural: '{{count}} عناصر في هذه الفئة',
		noMenuItems: 'لا توجد عناصر قائمة حتى الآن',
		noMenuItemsDescription: 'لم يتم إضافة عناصر قائمة إلى هذه الفئة حتى الآن.',
		addFirstMenuItem: 'إضافة أول عنصر قائمة',
		viewAll: 'عرض الكل',
	},
};